import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import { useLang, LangToggle } from '../i18n';

const MIN_CARDS = 100;

export default function CardSale() {
  const nav = useNavigate();
  const { lang } = useLang();
  const W = (zh, en) => lang === 'zh' ? zh : en;

  const [cardsAmount, setCards] = useState('');
  const [priceUsdt,   setPrice] = useState('');
  const [result,      setResult] = useState(null);
  const [myList,      setMyList] = useState(null);
  const [usdtBalance, setUsdtBalance] = useState(null);
  const [loading,     setL]      = useState(false);
  const [msg,         setMsg]    = useState('');
  const [tab,         setTab]    = useState('create');

  async function create(e) {
    e.preventDefault();
    const cards = parseInt(cardsAmount);
    const price = parseFloat(priceUsdt);
    if (cards < MIN_CARDS) { setMsg(`ERR:${W(`最低出售 ${MIN_CARDS} 张`, `Minimum ${MIN_CARDS} cards`)}`); return; }
    if (!price || price <= 0) { setMsg(W('ERR:请输入有效价格','ERR:Enter a valid price')); return; }
    setL(true); setMsg('');
    try {
      const r = await API.post('/api/card-sale/create', { cardsAmount: cards, priceUsdt: price });
      setResult(r);
      setCards(''); setPrice('');
    } catch(e) {
      const m = e.message || '';
      if (m.includes('不足')) setMsg(W('ERR:您的房卡不足，请稍后再试','ERR:Insufficient cards'));
      else setMsg(`ERR:${m}`);
    }
    finally { setL(false); }
  }

  async function loadMyList() {
    setTab('mylist');
    try {
      const [listRes, balanceRes] = await Promise.all([
        API.get('/api/card-sale/my/list'),
        API.get('/api/card-sale/my/balance'),
      ]);
      setMyList(listRes.list || []);
      setUsdtBalance(balanceRes.usdtBalance || '0.000000');
    } catch {
      setMyList([]);
      setUsdtBalance('0.000000');
    }
  }

  async function cancel(code) {
    if (!window.confirm(W('确认取消？取消后房卡退回你的账户','Cancel listing? Cards will be returned to your account'))) return;
    try {
      await API.post('/api/card-sale/my/cancel', { code });
      loadMyList();
    } catch(e) { alert(e.message); }
  }

  function copyLink() {
    navigator.clipboard.writeText(result.link);
    alert(W('链接已复制','Link copied'));
  }

  const statusLabel = {
    open:      W('挂单中','Listed'),
    pending:   W('待付款','Pending'),
    completed: W('已成交','Completed'),
    cancelled: W('已取消','Cancelled'),
    expired:   W('已过期','Expired'),
  };
  const statusColor = { open:'#F5C518', pending:'#2E7FE8', completed:'#2ECC71', cancelled:'#8BA8D4', expired:'#8BA8D4' };

  const S = `
    *{box-sizing:border-box;margin:0;padding:0;}
    .cs-root{min-height:100vh;background:linear-gradient(180deg,#0B1E4A 0%,#0D2B6B 50%,#091840 100%);
      background-attachment:fixed;padding-bottom:60px;}
    .cs-header{display:flex;align-items:center;gap:14px;padding:52px 20px 20px;
      border-bottom:1px solid rgba(46,127,232,0.15);}
    .cs-back{background:rgba(46,127,232,0.1);border:none;color:#8BA8D4;
      font-size:18px;cursor:pointer;padding:8px 12px;border-radius:10px;}
    .cs-title{font-size:20px;font-weight:800;color:#fff;}
    .cs-body{padding:18px 16px;}
    .cs-card{background:#0F2554;border-radius:16px;padding:18px;margin-bottom:14px;}
    .cs-label{font-size:11px;color:#8BA8D4;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px;}
    .cs-tabs{display:flex;gap:8px;margin-bottom:16px;}
    .cs-tab{flex:1;padding:10px;border-radius:10px;border:none;cursor:pointer;font-size:13px;font-weight:700;}
    .cs-tab.active{background:linear-gradient(180deg,#FFD700,#E6A800);color:#000;}
    .cs-tab:not(.active){background:rgba(46,127,232,0.1);color:#8BA8D4;}
    .btn-gold{width:100%;padding:13px;border-radius:12px;border:none;cursor:pointer;
      font-size:14px;font-weight:800;
      background:linear-gradient(180deg,#FFD700 0%,#E6A800 100%);color:#000;
      box-shadow:0 4px 0 #8B6200;}
    .btn-gold:active{transform:translateY(3px);box-shadow:0 1px 0 #8B6200;}
    .btn-gold:disabled{opacity:0.4;cursor:not-allowed;transform:none;box-shadow:none;}
    .btn-blue{width:100%;padding:13px;border-radius:12px;border:none;cursor:pointer;
      font-size:14px;font-weight:800;
      background:linear-gradient(180deg,#2E7FE8,#1a5fc4);color:#fff;
      box-shadow:0 4px 0 #0f3d8a;}
    .btn-blue:active{transform:translateY(3px);box-shadow:0 1px 0 #0f3d8a;}
    .msg-err{padding:10px 14px;border-radius:10px;font-size:13px;
      background:rgba(232,69,60,0.1);color:#E8453C;margin-bottom:12px;}
    .result-box{background:rgba(245,197,24,0.08);border-radius:14px;padding:18px;text-align:center;}
    .result-link{font-family:'Share Tech Mono',monospace;font-size:13px;color:#F5C518;
      word-break:break-all;margin:10px 0 16px;text-align:left;}
    .sale-row{padding:12px;border-radius:12px;background:rgba(46,127,232,0.07);margin-bottom:8px;}
    .sale-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;}
    .sale-info{font-size:14px;color:#fff;font-weight:700;}
    .sale-meta{font-size:11px;color:#8BA8D4;line-height:1.7;}
    .cancel-btn{margin-top:8px;padding:7px 12px;border-radius:9px;border:none;
      background:rgba(232,69,60,0.12);color:#E8453C;font-size:12px;font-weight:700;cursor:pointer;}
  `;

  return (
    <div className="cs-root">
      <style>{S}</style>
      <div className="cs-header">
        <button className="cs-back" onClick={() => nav('/lobby')}>&#8592;</button>
        <div className="cs-title">{W('房卡出售','Card Sale')}</div>
        <LangToggle />
      </div>

      <div className="cs-body">
        <div className="cs-tabs">
          <button className={`cs-tab${tab==='create'?' active':''}`} onClick={() => setTab('create')}>{W('创建挂单','Create Listing')}</button>
          <button className={`cs-tab${tab==='mylist'?' active':''}`} onClick={loadMyList}>{W('我的挂单','My Listings')}</button>
        </div>

        {tab === 'create' && (
          <>
            <div className="cs-card">
              <div className="cs-label">{W('出售房卡','Sell Cards')}</div>
              {msg && <div className="msg-err">{msg.replace('ERR:','')}</div>}
              {result ? (
                <div className="result-box">
                  <div style={{fontSize:13,color:'#8BA8D4',marginBottom:6}}>{W('交易链接已生成（24小时有效）','Link generated (valid 24h)')}</div>
                  <div className="result-link">{result.link}</div>
                  <div style={{fontSize:12,color:'#8BA8D4',marginBottom:16}}>
                    {W('房卡已锁定，买家付款后自动到账','Cards locked. Auto-credited after buyer pays.')}
                  </div>
                  <div style={{display:'flex',gap:10}}>
                    <button className="btn-gold" style={{flex:1}} onClick={copyLink}>{W('复制链接','Copy Link')}</button>
                    <button className="btn-blue" style={{flex:1}} onClick={() => setResult(null)}>{W('再创建一个','Create Another')}</button>
                  </div>
                </div>
              ) : (
                <form onSubmit={create} style={{display:'flex',flexDirection:'column',gap:12}}>
                  <div>
                    <div style={{fontSize:12,color:'#8BA8D4',marginBottom:6}}>{W(`出售数量（最低 ${MIN_CARDS} 张）`,`Quantity (min ${MIN_CARDS})`)}</div>
                    <input className="input" type="number" placeholder={W(`房卡数量，最低 ${MIN_CARDS} 张`,`Card qty, min ${MIN_CARDS}`)}
                      value={cardsAmount} onChange={e=>setCards(e.target.value)}
                      min={MIN_CARDS} step={1} required />
                  </div>
                  <div>
                    <div style={{fontSize:12,color:'#8BA8D4',marginBottom:6}}>{W('出售总价（USDT）','Total Price (USDT)')}</div>
                    <input className="input" type="number" placeholder={W('总价，单位 USDT，例如 5.00','Total in USDT, e.g. 5.00')}
                      value={priceUsdt} onChange={e=>setPrice(e.target.value)}
                      min={0.01} step={0.01} required />
                  </div>
                  <div style={{fontSize:11,color:'#4A6A9A',lineHeight:1.7}}>
                    {W('生成链接后房卡立即锁定 · 买家通过 PayTheFly 付款 · 付款成功后房卡自动到账',
                       'Cards locked on link creation · Buyer pays via PayTheFly · Auto-credited on success')}
                  </div>
                  <button className="btn-gold" type="submit" disabled={loading}>
                    {loading ? W('生成中...','Generating...') : W('生成交易链接','Generate Link')}
                  </button>
                </form>
              )}
            </div>
          </>
        )}

        {tab === 'mylist' && (
          <div className="cs-card">
            <div className="cs-label" style={{marginBottom:12}}>{W('我的挂单记录','My Listings')}</div>
            {usdtBalance !== null && (
              <div style={{
                padding:'12px',borderRadius:12,background:'rgba(46,204,113,0.08)',
                color:'#fff',fontSize:13,fontWeight:700,marginBottom:12,
              }}>
                {W('待人工结算余额：','Pending balance: ')}<span style={{color:'#2ECC71'}}>{parseFloat(usdtBalance).toFixed(6)} USDT</span>
              </div>
            )}
            {!myList ? (
              <div style={{fontSize:13,color:'#8BA8D4'}}>{W('加载中...','Loading...')}</div>
            ) : myList.length === 0 ? (
              <div style={{fontSize:13,color:'#8BA8D4'}}>{W('暂无挂单记录','No listings yet')}</div>
            ) : myList.map(s => (
              <div className="sale-row" key={s.code}>
                <div className="sale-top">
                  <div className="sale-info">{s.cards_amount} {W('张房卡','Cards')} · {parseFloat(s.price_usdt).toFixed(2)} USDT</div>
                  <div style={{fontSize:12,fontWeight:800,color:statusColor[s.status]||'#8BA8D4'}}>
                    {statusLabel[s.status]||s.status}
                  </div>
                </div>
                <div className="sale-meta">
                  {W('创建：','Created: ')}{new Date(s.created_at).toLocaleString(lang==='en'?'en-US':'zh-CN')}<br/>
                  {s.status==='open' && `${W('到期：','Expires: ')}${new Date(s.expires_at).toLocaleString(lang==='en'?'en-US':'zh-CN')}`}
                  {s.status==='completed' && <>
                    {W('成交：','Sold: ')}{new Date(s.completed_at).toLocaleString(lang==='en'?'en-US':'zh-CN')}<br/>
                    {W('收到：','Received: ')}<span style={{color:'#2ECC71',fontWeight:700}}>{parseFloat(s.price_usdt).toFixed(2)} USDT</span><br/>
                    {s.tx_hash && <span style={{wordBreak:'break-all'}}>
                      {W('哈希：','Tx: ')}<a href={`https://bscscan.com/tx/${s.tx_hash}`} target="_blank" rel="noreferrer"
                        style={{color:'#2E7FE8',fontSize:11}}>{s.tx_hash}</a>
                    </span>}
                  </>}
                </div>
                {s.status === 'open' && (
                  <>
                    <div style={{margin:'10px 0 6px',fontSize:12,color:'#8BA8D4'}}>{W('交易链接：','Listing Link:')}</div>
                    <div style={{
                      fontFamily:'Share Tech Mono',fontSize:12,color:'#F5C518',
                      wordBreak:'break-all',lineHeight:1.6,marginBottom:10,
                    }}>
                      {`${(process.env.REACT_APP_FRONTEND_URL||'https://roomx.org')}/buy/${s.code}`}
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <button
                        onClick={() => {
                          const link = `https://roomx.org/buy/${s.code}`;
                          if (navigator.clipboard && navigator.clipboard.writeText) {
                            navigator.clipboard.writeText(link).then(() => alert(W('链接已复制','Link copied')));
                          } else {
                            const ta = document.createElement('textarea');
                            ta.value = link;
                            ta.style.position = 'fixed';
                            ta.style.opacity = '0';
                            document.body.appendChild(ta);
                            ta.select();
                            document.execCommand('copy');
                            document.body.removeChild(ta);
                            alert(W('链接已复制','Link copied'));
                          }
                        }}
                        style={{
                          padding:'8px 16px',borderRadius:10,border:'none',cursor:'pointer',
                          background:'linear-gradient(180deg,#FFD700,#E6A800)',
                          color:'#000',fontSize:12,fontWeight:800,
                          boxShadow:'0 3px 0 #8B6200',
                        }}>
                        {W('复制链接','Copy Link')}
                      </button>
                      <button className="cancel-btn" onClick={() => cancel(s.code)}>{W('取消挂单','Cancel')}</button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
